import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
	selector: "app-alert",
	templateUrl: "./alert.html",
	styleUrls: ["./alert.css"],
})
export class AlertDirective {
	@Input()
	public heading: string;
	@Input()
	public message: string;
	@Input()
	public buttonLabel: string = "OK";
	@Input()
	public iconClass: string = "";
	@Output()
	public callback: EventEmitter<any> = new EventEmitter<any>();

	constructor() {}

	private close() {
		this.callback.emit("");
	}
}
